<ngx-loading-bar color="#0025f9"></ngx-loading-bar>
<router-outlet></router-outlet>
